













import { Component, Mixins } from "vue-property-decorator";
import { ExpressionKinds } from "../../../../../../documaker/domain/format/objects";
import { CalculatableObjectDrawerBase } from "./base";
import { default as NamedRectangleCoordinatableObjectDrawer } from "./NamedRectangleCoordinatableObjectDrawer.vue";

@Component({
  components: {
    NamedRectangleCoordinatableObjectDrawer,
  },
})
export default class CalculateObjectDrawer extends Mixins(CalculatableObjectDrawerBase) {
  get configurationKey(): string {
    switch (this.expressionKind) {
      case ExpressionKinds.Calculation:
        return "CalculateExpression";
      case ExpressionKinds.Conditional:
        return "ConditionalExpression";
      case ExpressionKinds.DateDuration:
        return "DurationExpression";
      case ExpressionKinds.TimeSpan:
        return "SpanExpression";
      case ExpressionKinds.DateComparison:
        return "DateCompareExpression";
      default:
        return "NotImplemented";
    }
  }

  get expressionKind(): ExpressionKinds {
    return this.readPropertyOrDefault(s => s.kind().getValue(), ExpressionKinds.Calculation);
  }
}
